<template>
  <nav role="navigation" class="navigation w-fit h-fit z-10 absolute">
    <div id="hamburger" class="block relative top-5 left-3 z-10">
      <input
        v-model="showSideBar"
        type="checkbox"
        class="block h-8 w-10 absolute -top-2 -left-1 cursor-pointer opacity-0 z-20"
      />
      <span class="w-8"></span>
      <span class="w-9"></span>
      <span class="w-8"></span>
      <ul id="menu" class="w-screen flex flex-col gap-3" :class="hideMenu">
        <router-link
          to="/"
          @click="toggleSidebar()"
          class="flex items-center justify-between w-20"
        >
          <em
            class="fa fa-home text-sm py-1 px-2 bg-[#6b6d70] rounded-full"
            aria-hidden="true"
          ></em>
          <p class="font-bold text-sm text-[#6b6d70]">Home</p>
        </router-link>
        <router-link
          to="/portfolio"
          class="flex items-center justify-between w-29"
          @click="toggleSidebar()"
        >
          <em
            class="fa fa-briefcase text-sm py-1 px-2 bg-[#6b6d70] rounded-full"
            aria-hidden="true"
          ></em>
          <p class="font-bold text-sm text-[#6b6d70]">Portfolio</p>
        </router-link>
        <router-link
          to="/about-me"
          class="flex items-center justify-between w-27"
          @click="toggleSidebar()"
        >
          <em
            class="fa fa-info-circle text-base py-0.5 px-2 bg-[#6b6d70] rounded-full"
            aria-hidden="true"
          ></em>
          <p class="font-bold text-sm text-[#6b6d70]">About Me</p></router-link
        >
        <router-link
          to="/contact"
          class="flex items-center justify-between w-31"
          @click="toggleSidebar()"
        >
          <em
            class="fa fa-phone text-base py-0.5 px-2 bg-[#6b6d70] rounded-full"
            aria-hidden="true"
          ></em>
          <p class="font-bold text-sm text-[#6b6d70]">
            Contact Me
          </p></router-link
        >
      </ul>
    </div>
  </nav>
</template>
<script setup>
import { ref } from "vue";

const showSideBar = ref(false);
function toggleSidebar() {
  showSideBar.value = !showSideBar.value;
}
</script>

<style scoped>
#hamburger {
  -webkit-user-select: none;
  user-select: none;
}

#hamburger a {
  text-decoration: none;
  color: rgb(249 198 17);
  transition: color 0.3s ease;
  text-transform: uppercase;
}

#hamburger a:hover {
  color: rgb(249 198 17);
}

#hamburger span {
  display: block;
  height: 4px;
  margin-bottom: 5px;
  position: relative;
  background: rgb(249 198 17);
  border-radius: 3px;
  z-index: 1;
  transform-origin: 4px 0px;
  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
    background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
}

#hamburger span:first-child {
  transform-origin: 0% 0%;
  width: 40px;
}

#hamburger span:nth-last-child(2) {
  transform-origin: 0% 100%;
}

#hamburger input:checked ~ span {
  opacity: 1;
  transform: rotate(45deg) translate(-2px, -1px);
  background: rgb(249 198 17);
}

#hamburger input:checked ~ span:nth-last-child(3) {
  opacity: 0;
  transform: rotate(0deg) scale(0.2, 0.2);
}

#hamburger input:checked ~ span:nth-last-child(2) {
  transform: rotate(-45deg) translate(0, -1px);
}

#menu {
  position: absolute;
  margin-top: -100px;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: -15px;
  padding: 50px;
  padding-right: 0;
  padding-top: 125px;
  background: #ebeff3;
  list-style-type: none;
  -webkit-font-smoothing: antialiased;
  transform-origin: 0% 0%;
  transform: translate(-100%, 0);
  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
  box-shadow: inset 0 0em 0em rgba(150, 150, 150, 0.1), 0 0 0 0.2px gray,
    1px 1px 1em rgba(0, 0, 0, 0.3);
  border-radius: 1px;
}

#menu a {
  padding: 5px 0;
  font-size: 22px;
}

#hamburger input:checked ~ ul {
  transform: none;
}

@media screen and (min-width: 1024px) {
  .navigation {
    display: none;
  }
}
</style>
